import { SEO } from '@cinch-nx/data-storyblok'

/**
 * The content here is formatted in the same way as the parsed JSON that comes back from Storyblok.
 * I decided to structure it in this way for parity with the other landing content driven pages, and so it's ewasier to swap storyblok in later on when we have more time
 */
export const SEO_CONTENT: SEO = {
  _uid: '14687260-46d4-402c-a5f5-9e63531f736e',
  title: 'New car offers',
  description:
    'Discover new car offers at our sister site, Marshall Motor Group. Learn more about the latest new car promotions and visit Marshall to buy your next car.',
  component: 'SEO',
}
